export default "__VITE_ASSET__c652025c__"